export const dataFields = {
	headline: {
		label: 'Headline',
		dataField: 'headline',
	},
	disclaimer: {
		label: 'Disclaimer',
		dataField: 'disclaimer',
	},
	title: {
		label: 'Title',
		dataField: 'title',
	},
	subTitle: {
		label: 'Sub Title',
		dataField: 'subTitle',
	},
	'listing.acreage': {
		label: 'Acreage',
		dataField: 'listing.acreage',
	},
	'listing.address': {
		label: 'Listing Address 1',
		dataField: 'listing.address',
	},
	'listing.address1': {
		label: 'Listing Address 2',
		dataField: 'listing.address1',
	},
	'listing.agentCompanyName': {
		label: 'Listing Agent Company Name',
		dataField: 'listing.agent_company_name',
	},
	'listing.agentName': {
		label: 'Listing Agent Name',
		dataField: 'listing.agent_name',
	},
	'listing.agentPhoneNumber': {
		label: 'Listing Agent Phone Number',
		dataField: 'listing.agent_phone_number',
	},
	'listing.area': {
		label: 'Area',
		dataField: 'listing.area',
	},
	'listing.baths': {
		label: 'Bathrooms',
		dataField: 'listing.baths',
	},
	'listing.beds': {
		label: 'Bedrooms',
		dataField: 'listing.beds',
	},
	'listing.buyer_commission': {
		label: 'Buyer Commission',
		dataField: 'listing.buyer_commission',
	},
	'listing.buyingAgentId': {
		label: 'Buying Agent Id',
		dataField: 'listing.buying_agent_id',
	},
	'listing.buyingAgentName': {
		label: 'Buying Agent Name',
		dataField: 'listing.buying_agent_name',
	},
	'listing.city': {
		label: 'City',
		dataField: 'listing.city',
	},
	'listing.communityName': {
		label: 'Community',
		dataField: 'listing.community_name',
	},
	'listing.country': {
		label: 'Country',
		dataField: 'listing.country',
	},
	'listing.description': {
		label: 'MLS Description',
		dataField: 'listing.description',
	},
	'listing.disclaimer': {
		label: 'Disclaimer',
		dataField: 'listing.disclaimer',
	},
	'listing.garage': {
		label: 'Garage',
		dataField: 'listing.garage',
	},
	'listing.image_data_0': {
		label: 'Image 1',
		dataField: 'listing.image_data_0',
	},
	'listing.image_data_1': {
		label: 'Image 2',
		dataField: 'listing.image_data_1',
	},
	'listing.image_data_2': {
		label: 'Image 3',
		dataField: 'listing.image_data_2',
	},
	'listing.image_data_3': {
		label: 'Image 4',
		dataField: 'listing.image_data_3',
	},
	'listing.image_data_4': {
		label: 'Image 5',
		dataField: 'listing.image_data_4',
	},
	'listing.image_data_5': {
		label: 'Image 6',
		dataField: 'listing.image_data_5',
	},
	'listing.image_data_6': {
		label: 'Image 7',
		dataField: 'listing.image_data_6',
	},
	'listing.image_data_7': {
		label: 'Image 8',
		dataField: 'listing.image_data_7',
	},
	'listing.image_data_8': {
		label: 'Image 9',
		dataField: 'listing.image_data_8',
	},
	'listing.image_data_9': {
		label: 'Image 10',
		dataField: 'listing.image_data_9',
	},
	'listing.listPrice': {
		label: 'List Price',
		dataField: 'listing.list_price',
	},
	'listing.listPriceSqFoot': {
		label: 'Price per Sq Ft',
		dataField: 'listing.list_price_sq_foot',
	},
	'listing.listingtype': {
		label: 'Listing Type',
		dataField: 'listing.listingtype',
	},
	'listing.listings_commission': {
		label: 'Listings Commission',
		dataField: 'listing.listings_commission',
	},
	'listing.listing_comp_value': {
		label: 'Listing Compensation',
		dataField: 'listing.listing_comp_value',
	},
	'listing.buyer_comp_value': {
		label: 'Buyer Compensation',
		dataField: 'listing.buyer_comp_value',
	},
	'listing.lotsize': {
		label: 'Lot Size',
		dataField: 'listing.lot_size',
	},
	'listing.mlsNumber': {
		label: 'MLS Number',
		dataField: 'listing.mls_number',
	},
	'listing.mlsName': {
		label: 'MLS Name',
		dataField: 'listing.mls_name',
	},
	'listing.salePrice': {
		label: 'Sale Price',
		dataField: 'listing.saleprice',
	},
	'listing.sqFoot': {
		label: 'Sq Ft',
		dataField: 'listing.sq_foot',
	},
	'listing.state': {
		label: 'State',
		dataField: 'listing.state',
	},
	'listing.status': {
		label: 'Listing Status',
		dataField: 'listing.status',
	},
	'listing.statusCode': {
		label: 'Status Code',
		dataField: 'listing.status_code',
	},
	'listing.style': {
		label: 'Style',
		dataField: 'listing.style',
	},
	'listing.type': {
		label: 'Type',
		dataField: 'listing.type',
	},
	'listing.units': {
		label: 'Units',
		dataField: 'listing.units',
	},
	'listing.url': {
		label: 'Listing URL',
		dataField: 'listing.url',
	},
	'listing.zip': {
		label: 'Zip / Postal Code',
		dataField: 'listing.zip',
	},
	'listing.zoning': {
		label: 'Zoning',
		dataField: 'listing.zoning',
	},
	'listing.banner_text': {
		label: 'Banner Text',
		dataField: 'listing.banner_text',
	},
	'user.city': {
		label: 'City',
		dataField: 'user.city',
	},
	'user.country': {
		label: 'County',
		dataField: 'user.country',
	},
	'user.postalCode': {
		label: 'Postal Code',
		dataField: 'user.postalCode',
	},
	'user.stateProvince': {
		label: 'State or Province',
		dataField: 'user.stateProvince',
	},
	'user.streetAddress': {
		label: 'Street Address',
		dataField: 'user.streetAddress',
	},
	'user.websiteUrl': {
		label: 'Website URL',
		dataField: 'user.websiteUrl',
	},
	'user.email': {
		label: 'Email',
		dataField: 'user.email',
	},
	'user.firstName': {
		label: 'First Name',
		dataField: 'user.firstName',
	},
	'user.lastName': {
		label: 'Last Name',
		dataField: 'user.lastName',
	},
	'user.fullName': {
		label: 'Full Name',
		dataField: 'user.fullName',
	},
	'user.displayName': {
		label: 'Display Name',
		dataField: 'user.displayName',
	},
	'user.imageUrl': {
		label: 'Profile Image',
		dataField: 'user.imageUrl',
	},
	'user.mobilePhone': {
		label: 'Mobile Phone',
		dataField: 'user.mobilePhone',
	},
	'user.primaryPhone': {
		label: 'Direct Phone',
		dataField: 'user.primaryPhone',
	},
	'user.displayPhone': {
		label: 'Display Phone',
		dataField: 'user.displayPhone',
	},
	'user.brandPrimaryColor': {
		label: 'Brand Primary Color',
		dataField: 'user.brandPrimaryColor',
	},
	'user.brandSecondaryColor': {
		label: 'Brand Secondary Color',
		dataField: 'user.brandSecondaryColor',
	},
	'user.brandTertiaryColor': {
		label: 'Brand Tertiary Color',
		dataField: 'user.brandTertiaryColor',
	},
	'user.brandAccentColor': {
		label: 'Brand Accent Color',
		dataField: 'user.brandAccentColor',
	},
	'user.logoDarkUrl': {
		label: 'Dark Logo',
		dataField: 'user.logoDarkUrl',
	},
	'user.logoLightUrl': {
		label: 'Light Logo',
		dataField: 'user.logoLightUrl',
	},
	'user.licenseNumber': {
		label: 'Display License Number',
		dataField: 'user.licenseNumber',
	},
	'user.companyName': {
		label: 'Company Name',
		dataField: 'user.companyName',
	},
	'user.companyPhone': {
		label: 'Company Phone',
		dataField: 'user.companyPhone',
	},
	'user.disclaimer': {
		label: 'Disclaimer',
		dataField: 'user.disclaimer',
	},
	'user.title': {
		label: 'Title',
		dataField: 'user.title',
	},
	'user.certifications': {
		label: 'Certifications',
		dataField: 'user.certifications',
	},
	'user.birthday': {
		label: 'Birthday',
		dataField: 'user.birthday',
	},
	'user.listing_commission': {
		label: 'Listings Commission Label',
		dataField: 'user.listing_commission',
	},
	'user.buyer_commission': {
		label: 'Buyer Commission Label',
		dataField: 'user.buyer_commission',
	},
	'current_date.day': {
		label: 'Current Day',
		dataField: 'current_date.day',
		accessLevel: 'admin',
	},
	'current_date.month': {
		label: 'Current Month',
		dataField: 'current_date.month',
		accessLevel: 'admin',
	},
	'current_date.year': {
		label: 'Current Year',
		dataField: 'current_date.year',
		accessLevel: 'admin',
	},
	'content_locations.city': {
		label: 'Localized Content City',
		dataField: 'content_locations.city',
		accessLevel: 'globalAdmin',
	},
	'content_locations.zip': {
		label: 'Localized Content Zip',
		dataField: 'content_locations.zip',
		accessLevel: 'globalAdmin',
	},
	'altos.avg_days_on_market': {
		label: 'Avg Days on Market',
		dataField: 'altos.mean_dom',
		accessLevel: 'globalAdmin',
	},
	'altos.avg_price_per_sq_ft': {
		label: 'Price Per Sq Foot',
		dataField: 'altos.mean_per_sqft',
		accessLevel: 'globalAdmin',
	},
	'altos.inventory': {
		label: 'Inventory Count',
		dataField: 'altos.count',
		accessLevel: 'globalAdmin',
	},
	'altos.max_price': {
		label: 'Highest Listed Price',
		dataField: 'altos.max_price',
		accessLevel: 'globalAdmin',
	},
	'altos.median_days_on_market': {
		label: 'Median Days on Market',
		dataField: 'altos.dom_median',
		accessLevel: 'globalAdmin',
	},
	'altos.median_home_price': {
		label: 'Median Home Price',
		dataField: 'altos.median_price',
		accessLevel: 'globalAdmin',
	},
	'altos.median_listing_price': {
		label: 'Median Listing Price',
		dataField: 'altos.price_median',
		accessLevel: 'globalAdmin',
	},
	'altos.median_new_listing_price': {
		label: 'New Listing Price Median',
		dataField: 'altos.median_price_of_new_listings',
		accessLevel: 'globalAdmin',
	},
	'altos.median_price_per_sq_foot': {
		label: 'Median Price Per Sq Foot',
		dataField: 'altos.per_sqft_median',
		accessLevel: 'globalAdmin',
	},
	'altos.min_price': {
		label: 'Lowest Listed Price',
		dataField: 'altos.min_price',
		accessLevel: 'globalAdmin',
	},
};
